import React, { cloneElement, forwardRef } from 'react'
import { Input } from '@mantine/core'
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd'
import { useUncontrolled } from '@mantine/hooks'
import { IconMaps } from '@ow/icons'
import styled from '@emotion/styled'

const DragContainer = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 40px;

  .mantine-RadioDragGroup-radioWrapper {
    width: 100%;
  }

  .mantine-RadioGroup-radioWrapper {
    width: 100%;
  }

  .mantine-RadioGroup-label,
  .mantine-RadioDragGroup-label {
    flex: 1;
  }
`
// const filterChildrenByType = (children, type) => {
//   return Children.toArray(children).filter((item) =>
//     Array.isArray(type)
//       ? type.some((component) => component === item.type)
//       : item.type === type
//   )
// }

// children的结构是个 dom 数组，数组内 dom 的第一个子元素是对应的 radio 或者 checkbox
const DragGroup = (
  {
    id,
    // name,
    onDragEnd,
    children,
    list,
    keyProp,
    value,
    defaultValue,
    color,
    size,
    classNames,
    styles,
    onChange,
    groupType = 'radio',
  },
  ref
) => {
  const [_value, setValue] = useUncontrolled({
    value,
    defaultValue,
    finalValue: '',
    onChange,
  })

  const radios = () => {
    return children.map((radioItem, index) => {
      // 改写一下 radio,让 click 和 useUncontrolled 联动使用
      const radio = cloneElement(radioItem.props.children[0], {
        key: 'drag' + index,
        checked: _value === radioItem.props.children[0].props.value,
        // name: uuid,
        color,
        size,
        classNames,
        styles,
        __staticselector: 'RadioDragGroup',
        onChange: () => {},
        onClick: (event) => {
          return _value === event.currentTarget.value
            ? setValue('')
            : setValue(event.currentTarget.value)
        },
      })

      const [...newChildren] = radioItem.props.children
      newChildren[0] = radio

      return (
        <Draggable
          key={list[index][keyProp]}
          draggableId={`${list[index][keyProp]}`}
          index={index}
        >
          {(provided) => (
            <DragContainer
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
            >
              <IconMaps type="drag" fill="#181818" width={20} height={20} />
              {cloneElement(radioItem, {}, newChildren)}
              {provided.placeholder}
            </DragContainer>
          )}
        </Draggable>
      )
    })
  }

  const checkBoxs = () =>
    children.map((checkboxItem, index) => {
      // 改写一下 checkbox,让 click 和 useUncontrolled 联动使用
      const checkbox = cloneElement(checkboxItem.props.children[0], {
        key: index,
        checked: _value.includes(checkboxItem.props.children[0].props.value),
        // name: uuid,
        color,
        size,
        classNames,
        styles,
        __staticselector: 'CheckBoxGroup',
        onChange: (event) => {
          const curValue = checkbox.props.value
          if (_value.includes(event.currentTarget.value)) {
            setValue(_value.filter((e) => e !== curValue))
          } else {
            setValue(_value.concat([curValue]))
          }
        },
      })

      const [...newChildren] = checkboxItem.props.children
      newChildren[0] = checkbox

      return (
        <Draggable
          key={list[index][keyProp]}
          draggableId={`${list[index][keyProp]}`}
          className="w-full"
          index={index}
        >
          {(provided) => (
            <DragContainer
              ref={provided.innerRef}
              {...provided.draggableProps}
              {...provided.dragHandleProps}
              className="flex w-full"
            >
              <IconMaps type="drag" fill="#181818" width={20} height={20} />
              {cloneElement(checkboxItem, {}, newChildren)}

              {provided.placeholder}
            </DragContainer>
          )}
        </Draggable>
      )
    })

  return (
    list && (
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable2">
          {(firstProvided) => (
            <div
              className="w-full"
              ref={firstProvided.innerRef}
              {...firstProvided.droppableProps}
            >
              <Input.Wrapper
                className="w-full"
                id={id}
                ref={ref}
                orientation="vertical"
              >
                {groupType === 'radio' ? radios() : checkBoxs()}
              </Input.Wrapper>
              {firstProvided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    )
  )
}

export default forwardRef(DragGroup)
